import regeneratorRuntime from "regenerator-runtime";
import Dashboardjs from './dashboard';
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class DeclarationOfCasesjs {

    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
        this.dashboardjs = new Dashboardjs;
    }

    async submitDeclaration(e) {

        e.preventDefault();
        const that = this;
        this.utilsjs.disableButton(e);

        $('.declare-btns-block .declare-loading').show();
        var statusText = await that.ajaxjs.serializeAndPostForm(e.target.id, 'SubmitDeclaration', 'Member');
        if (statusText === '202') {
            setTimeout(() => {
                $('.declare-btns-block .declare-loading').hide();
                location.reload(); //Reload page when AutoCloseCycle
            }, 1500);
        } else {
            $('.declare-btns-block .declare-loading').hide();
            if (statusText === '201') {
                $('.declaration-incomplete').hide();
                $('.declaration-complete').show();
                this.dashboardjs.checkIfCycleIsComplete();
                window.scrollTo(0, 200);
            } else {
                $("#declaration").prop("checked", false);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/declarationOfCases.js